export default function FloatingWhatsApp() {
  return (
    <a
      href="https://wa.me/34633759649"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-12 h-12 sm:w-14 sm:h-14 bg-green-600 rounded-full flex items-center justify-center shadow-lg hover:bg-green-700 transition-all hover:scale-110 cursor-pointer animate-pulse"
      aria-label="Contactar por WhatsApp"
    >
      <i className="ri-whatsapp-fill text-white text-xl sm:text-2xl"></i>
    </a>
  );
}
